var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31732 1.35335L1.31734 1.35333C1.3932 1.28452 1.52468 1.20656 1.82432 1.20656C2.1134 1.20656 2.2317 1.28147 2.29602 1.34047C2.36221 1.40153 2.41313 1.47356 2.41313 1.66869C2.41313 1.78941 2.38625 1.84242 2.31086 1.91173L2.31007 1.91245C2.23762 1.97916 2.10615 2.0601 1.79537 2.0601H1.78089C1.50142 2.0601 1.38794 1.98652 1.32236 1.92435L0.492278 2.8L1.32236 1.92435C1.24575 1.85173 1.20656 1.78226 1.20656 1.62626C1.20656 1.48235 1.24111 1.42246 1.31732 1.35335ZM7.58042 7.13182C7.51476 7.24625 7.45568 7.36534 7.40339 7.48892C7.23292 7.88722 7.19112 8.33078 7.19112 8.72525V12.7934H6.39782C6.41188 10.523 6.41892 8.71415 6.41892 7.36768C6.41892 7.28755 6.41889 7.20892 6.41885 7.13182H7.58042ZM6.41883 7.11466C6.41848 6.59204 6.41699 6.1395 6.41417 5.7601H7.11227L6.41883 7.11466ZM12.3412 6.62028C11.885 6.01953 11.2524 5.71788 10.5738 5.63425C10.7963 5.56644 11.0397 5.53384 11.3079 5.53384C12.1297 5.53384 12.6877 5.78752 13.106 6.23401C13.4993 6.65386 13.7934 7.36852 13.7934 8.58384V12.7934H12.9923V8.95152C12.9923 8.12133 12.8407 7.27796 12.3412 6.62028ZM1.39479 12.7934V5.7601H2.19595V12.7934H1.39479Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.41313
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fbIcon.8c0ffa9101b8c544883228faae145988.svg";
export { ForwardRef as ReactComponent };